import styled from 'styled-components';
import { Paper, Box, Typography, Button } from '@mui/material';
import { palette } from 'utils/styles/variables';

const StyledPagePaper = styled(Paper)``;

const StyledTableWrapper = styled(Box)`
  padding-top: 12px;
`;
const StyledDetailsContainer = styled(Box)<{
  $firstCol?: boolean;
}>`
  && {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: right;
    ${({ $firstCol }) =>
      $firstCol &&
      `
      height: 100%;
      justify-content: center;
      text-align: left;
      gap: 16px;
    `}
  }
`;

const StyledReportInfo = styled(Typography)`
  && {
    overflow: hidden;
    color: ${palette.warning[400]};
    text-overflow: ellipsis;

    /* New/TableTextDefault */
    font-family: Poppins, sans-serif;
    font-size: 0.813rem;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
  }
`;

const StyledLinkButton = styled.span`
  && {
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${palette.primary.main};
    cursor: pointer;
  }
`;

const StyledInvoiceApproveButton = styled(Button)`
  && {
    min-width: 104px;
    padding: 2px 24px;
    border-radius: 3px;

    font-family: Poppins, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;

    color: #ffffff;
  }
`;

const StyledReportCSVButton = styled(Button)`
  && {
    min-width: auto;

    & > .MuiButton-startIcon {
      margin: 0;
    }

    &:hover {
      background: transparent;
    }
  }
`;

export {
  StyledDetailsContainer,
  StyledPagePaper,
  StyledTableWrapper,
  StyledReportInfo,
  StyledLinkButton,
  StyledInvoiceApproveButton,
  StyledReportCSVButton,
};
